<template>
    <b-container>
        <b-navbar toggleable="md" variant="primary" type="dark">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

            <b-navbar-brand href="#">
                <img src="@shared/_assets/logo.png" alt="Pb-shop logo" class="navbar__brand-img">
            </b-navbar-brand>

            <b-collapse is-nav id="nav_collapse">

                <b-navbar-nav>
                    <b-nav-item active-class="active" v-for="tab in tabs" :key="tab.name" :to="tab.link">{{ tab.name }}
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right no-caret class="navbar__profile-container">
                        <!-- Using button-content slot -->
                        <template slot="button-content">
                            <span class="navbar__profile-text">{{ username }}</span>
                            <i class="mdi mdi-person navbar__profile-icon"></i>
                        </template>
                        <b-dropdown-item :to="userProfileLink">Profile</b-dropdown-item>
                        <b-dropdown-item @click="onLogout">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-modal ref="gallery"
                 id="gallery"
                 size="xl"
                 cancel-only="true"
                 title="Gallery">
            <image-gallary key="gallery"/>
        </b-modal>
    </b-container>


</template>

<script>
import {mapState, mapActions} from 'vuex'
import ImageGallery from "@client/src/components/ImageGallery";

export default {
    components: {
        'image-gallary': ImageGallery
    },
    name: 'Navbar',
    props: {
        tabs: Array,
        userProfileLink: String,
        username: String
    },
    data: function () {
        return {
            variant: '',
            size: 30
        }
    },
    methods: {
        ...mapActions('account', ['logout']),
        onLogout() {
            this.logout().then(() => {
                this.$router.push('/cmslogin');
            });
        }
    },
    computed: {
        ...mapState('account', ['status']) // TODO why it is needed
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.navbar__profile-icon {
    font-size: 32px;
    color: white; // TODO colors
    &:hover {
        color: #fffff0; // TODO
    }

    &:active {
        color: #fffff0; // TODO
    }
}

.navbar__brand-img {
    height: 40px;
}

.navbar__profile-container {
    width: 200px;
    text-align: right;
    position: relative;
}

.navbar__profile-text {
    position: absolute;
    top: 15px;
    right: 50px;
}

</style>
